import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cart, CartRequest } from '../../features/events/models/cart.model';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../models/api-response.model';
import { ApiRoutes } from '../constants/api-routes.constants';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  constructor(private http: HttpClient) {}

  getCartById(cartId: number, purchaseType: 'raffle' | 'subscription'): Observable<ApiResponse<Cart>> {
    return this.http.get<ApiResponse<Cart>>(
      ApiRoutes.CART.GET_USER_CART_BY_IDENTIFIER(cartId, purchaseType)
    );
  }

  addTicketToCards(cart: CartRequest): Observable<ApiResponse<Cart>> {
    return this.http.post<ApiResponse<Cart>>(ApiRoutes.CART.ADD_TO_CART, cart);
  }
}
